import * as enums from "../enums"; 

export interface MetricBase<T> {
    name: string; 
    type: enums.MetricType;
    metric: T;    
}
export interface Series<T> {
    name: string; 
    categories: string[]; 
    data: T[]; 
}

export interface MetricWithSeries<T> extends MetricBase<T> {
    series1: Series<T>; 
    series2: Series<T>;
}

export interface TrendMetric<T> extends MetricBase<T> {
    trend: number;
}

export const defaultMetricBase = {
    name: "", 
    type: enums.MetricType.Count, 
    metric: 0,
}

export const defaultSeries = {
    name:"",
    categories:[],
    data:[]
}

export const defaultMetricWithSeries = {
    name: "",
    metric: 0,
    type: enums.MetricType.Count,
    series1: defaultSeries,
    series2: defaultSeries,
}

export const defaultTrendMetric = {
    ...defaultMetricWithSeries,
    trend: 0,
}